(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fy-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fyhm-quick-add')) {
    class FyhQuickAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        if (!this.button) return;
        this.onClick = this.add.bind(this);
        this.button.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }
      add() {
        var self = this;
        var d = this.dataset;
        this.button.disabled = true;
        this.button.textContent = d.labelAdding;
        this.status.textContent = '';
        fetch(d.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(d.variantId), quantity: 1 }] })
        })
          .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
          .then(function (r) {
            if (!r.ok) throw new Error((r.j && (r.j.description || r.j.message)) || d.labelError);
            self.button.textContent = d.labelAdded;
            self.status.textContent = d.labelAdded;
            self.refreshCart();
            setTimeout(function () {
              self.button.textContent = d.label;
              self.button.disabled = false;
            }, 2000);
          })
          .catch(function (err) {
            self.button.textContent = d.label;
            self.button.disabled = false;
            self.status.textContent = err && err.message ? err.message : d.labelError;
          });
      }
      refreshCart() {
        var cartUrl = this.dataset.cartUrl;
        fetch(cartUrl)
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (cart) {
            if (!cart) return;
            try {
              if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
                window.Shopify.onCartUpdate(cart);
              } else if (typeof window.CD_REFRESHCART === 'function') {
                window.CD_REFRESHCART().then(function () {
                  if (typeof window.CD_OPENCART === 'function') window.CD_OPENCART();
                });
              }
            } catch (e) {}
            ['[data-cart-count]', '.cart-count-bubble span', '.cart-count', '[data-cart-item-count]'].forEach(function (sel) {
              document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; });
            });
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          })
          .catch(function () {});
      }
    }
    customElements.define('fyhm-quick-add', FyhQuickAdd);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fy-video-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fyhm-autovideo')) {
    class FyhAutoVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('button');
        this.label = this.querySelector('[data-toggle-label]');
        this.userPaused = false;
        this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.video || !this.toggle) return;

        this.onToggle = this.handleToggle.bind(this);
        this.toggle.addEventListener('click', this.onToggle);
        this.onPlay = this.sync.bind(this);
        this.video.addEventListener('play', this.onPlay);
        this.video.addEventListener('pause', this.onPlay);

        if ('IntersectionObserver' in window) {
          var self = this;
          this.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting && e.intersectionRatio >= 0.5) {
                if (!self.reduce && !self.userPaused) self.play();
              } else if (!self.video.paused) {
                self.video.pause();
              }
            });
          }, { threshold: [0, 0.5] });
          this.io.observe(this);
        }
        this.sync();
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
      }
      play() {
        var p = this.video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
      handleToggle() {
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }
      sync() {
        var playing = !this.video.paused;
        this.toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
        if (this.label) this.label.textContent = playing ? this.dataset.labelPause : this.dataset.labelPlay;
      }
    }
    customElements.define('fyhm-autovideo', FyhAutoVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
